import {
  Mail,
  FileText,
  MessageCircle,
  MessageCircleMore,
  MessageSquare,
  Paperclip,
  Calendar,
  StickyNote,
  type LucideIcon,
} from 'lucide-react';
import type { EventType } from '@casetrace/shared';

export const TYPE_ICONS: Record<EventType, LucideIcon> = {
  email: Mail,
  document: FileText,
  sms: MessageCircle,
  imessage: MessageCircleMore,
  whatsapp: MessageSquare,
  attachment: Paperclip,
  meeting: Calendar,
  note: StickyNote,
  system_import: FileText,
};

export const TYPE_COLORS: Record<EventType, string> = {
  email: '#6366f1',
  sms: '#22c55e',
  imessage: '#38bdf8',
  whatsapp: '#25d366',
  document: '#94a3b8',
  attachment: '#f97316',
  meeting: '#a855f7',
  note: '#eab308',
  system_import: '#64748b',
};

export const TYPE_LABELS: Record<EventType, string> = {
  email: 'E-post',
  document: 'Dokument',
  sms: 'SMS',
  imessage: 'iMessage',
  whatsapp: 'WhatsApp',
  attachment: 'Vedlegg',
  meeting: 'Møte',
  note: 'Notat',
  system_import: 'Import',
};
